/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Action_Draft_MetaInputs */

const en_us2_search_action_draft_meta = /** @type {(inputs: Search_Action_Draft_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new plan from your trainer`)
};

const pt_br2_search_action_draft_meta = /** @type {(inputs: Search_Action_Draft_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo plano do personal`)
};

const es_419_search_action_draft_meta = /** @type {(inputs: Search_Action_Draft_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un plan nuevo de tu entrenador`)
};

const pt_pt2_search_action_draft_meta = /** @type {(inputs: Search_Action_Draft_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um plano novo do treinador`)
};

const fr_fr2_search_action_draft_meta = /** @type {(inputs: Search_Action_Draft_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un nouveau programme de ton coach`)
};

const de_de2_search_action_draft_meta = /** @type {(inputs: Search_Action_Draft_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein neuer Plan von deinem Coach`)
};

const it_it2_search_action_draft_meta = /** @type {(inputs: Search_Action_Draft_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una nuova scheda dal tuo coach`)
};

/**
* | output |
* | --- |
* | "A new plan from your trainer" |
*
* @param {Search_Action_Draft_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_action_draft_meta = /** @type {((inputs?: Search_Action_Draft_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Action_Draft_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_action_draft_meta(inputs)
	if (locale === "es-419") return es_419_search_action_draft_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_search_action_draft_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_search_action_draft_meta(inputs)
	if (locale === "de-DE") return de_de2_search_action_draft_meta(inputs)
	if (locale === "it-IT") return it_it2_search_action_draft_meta(inputs)
	return en_us2_search_action_draft_meta(inputs)
});
export { search_action_draft_meta as "search.action_draft_meta" }